import { getLayerFromDatabase } from '../api'

const initialState = {
    isLoading: true,
    layers: [{}],
    streets: [{}],
    sections: [{}],
    neighborhoods: [{}],
    facilities: [{}],
    pein: [{}],
    polygons: [{}],
    visibleVectors: {
        parcels: true,
        streets: false,
        neighborhoods: false,
        sections: false,
        facilities: false,
    },
    view: 'indice_dependencia'
}

export const layers =({
    state: initialState,
    reducers: {
        setLayer(state, layer, _v) {
            const { view, value } = _v
            let v = value === 'ndvi' ? 'ndvi' : view
            return {
                ...state,
                layers: layer,
                isLoading: false,
                view: v,
                visibleVectors: { ...state.visibleVectors, [value]: !state.visibleVectors[value] }
            }
        },
        setView(state, view) {
            return {
                ...state,
                view: view
            }
        },
        setStreets(state, lines, _v) {
            const { value, view } = _v
            return {
                ...state,
                streets: value === 'streets' ? lines : [{}],
                visibleVectors: { ...state.visibleVectors, [value]: !state.visibleVectors[value] },
                isLoading:false,
                view: view
            }
        },
        setNeighborhoods(state, polygons, _v) {
            const { value, view } = _v
            return {
                ...state,
                neighborhoods: value === 'neighborhoods' ? polygons : [{}],
                visibleVectors: { ...state.visibleVectors, [value]: !state.visibleVectors[value] },
                isLoading:false,
                view: view
            }
        },
        setSections(state, polygons, _v) {
            const { value, view }= _v
            return {
                ...state,
                sections: value == 'sections' ? polygons : [{}],
                visibleVectors: { ...state.visibleVectors, [value]: !state.visibleVectors[value] },
                isLoading:false,
                view: view
            }
        },
        setFacilities(state, polygons, _v) {
            const { value, view }= _v
            return {
                ...state,
                facilities: value == 'facilities' ? polygons : [{}],
                visibleVectors: { ...state.visibleVectors, [value]: !state.visibleVectors[value] },
                isLoading:false,
                view: view
            }
        },
        setPEIN(state, polygons, _v) {
            const { value, view  }= _v
            return {
                ...state,
                pein: value == 'pein' ? polygons : [{}],
                visibleVectors: { ...state.visibleVectors, [value]: !state.visibleVectors[value] },
                isLoading:false,
                view: view
            }
        },
        setVisibleVectors(state, _v) {
            if ( _v in state.visibleVectors) {
                state.visibleVectors[_v] = !state.visibleVectors[_v]
            }
            return  { ...state, ...state.visibleVectors }
        },
        setPolygons(state, _v) {
            return {
                ...state,
                polygons: []
            }
        }
    },
    effects: {
        async loadDatabaseLayer(_v) {
            const { endpoint, key, view } = _v || 'indices_pob'
            const layerEndpoint =  endpoint  || 'indices_pob'
            const layer = await getLayerFromDatabase(layerEndpoint)
            this.setLayer(layer, _v)
           // this.passLayerView(key)
        },
        async loadDatabaseLines(_v) {
            const { endpoint, key, view, value } = _v || 'indices_pob'
            const layerEndpoint = endpoint || 'indices_pob'
            const SLOPE_VIEWS = new Set([
                'coche_salud_clase',
                'peatonal_bus_clase',
                'distancia_peatonal',
                'coche_educacion_clase'
            ]);
            const ref = SLOPE_VIEWS.has(view) && value.includes('street') ? 'street_slope' : layerEndpoint;
            const layer = await getLayerFromDatabase(ref);
            const ROUTE_LAYERS = {
                'streets': () => this.setStreets(layer, _v),
                'parcels': () => null,
                'sections': () => this.setSections(layer, _v),
                'neighborhoods': () => this.setNeighborhoods(layer, _v),
                'facilities': () => this.setFacilities(layer, _v),
                'ndvi': () => this.setLayer(layer, _v),
                'pein': () => this.setPEIN(layer, _v)
            }
            const selectedAction = ROUTE_LAYERS[value]
            return selectedAction ? selectedAction() : null
        },
        setVisibleVectors(_v) {
            this.setVisibleVectors(_v)
        },
        passLayerView(view) {
            this.setView(view)
        }
    }
})
